import React, { useEffect, useState } from 'react';
import { FaWhatsapp, FaArrowDown } from 'react-icons/fa';
import { WHATSAPP_GENERAL_LINK } from '../data/products';

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        { image: '/images/cheesecake-frambuesa.jpg', title: 'Cheesecakes Frambuesa', subtitle: 'Dulce Mora', description: 'Hecho con amor, para endulzar tus mejores momentos' },
        { image: '/images/kuchen-nuez.jpg', title: 'kuchen Nuez', subtitle: 'Irresistibles', description: 'Cremosos, frescos y elaborados con ingredientes naturales' },
        { image: '/images/pie-limon.jpg', title: 'Pie Limón', subtitle: 'Artesanal', description: 'Tradición sureña que enamora en cada bocado' },
        { image: '/images/waffles.jpg', title: 'Waffles', subtitle: 'Artesanal', description: 'Suaves por dentro, crujientes por fuera' },
        { image: '/images/arroz-con-leche.jpg', title: 'Arroz con Leche', subtitle: 'Artesanal', description: 'Cremoso, suave y preparado con ingredientes naturales' },
        { image: '/images/cheesecake-maracuya.jpg', title: 'Cheesecake Maracuyá', subtitle: 'Irresistibles', description: 'Fresco, cremoso e irresistible. Sabor tropical con maracuyá natural' },
        { image: '/images/cheesecake-frutilla.jpg', title: 'Cheesecake Frutilla', subtitle: 'Irresistibles', description: 'Fresco, cremoso e irresistible. Con frutillas naturales' },
        { image: '/images/leche-asada.jpg', title: 'Leche Asada', subtitle: 'Artesanal', description: 'Suaves, cremosa y casera. El sabor de la tradición que enamora' },
    ];

    useEffect(() => {
        const timer = setInterval(() => setCurrentSlide((prev) => (prev + 1) % slides.length), 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    return (
        <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden">
            {slides.map((slide, index) => (
                <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}>
                    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${slide.image})` }} />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40" />
                    <div className="absolute inset-0 bg-gradient-to-t from-dulce-pink-900/40 via-transparent to-transparent" />
                </div>
            ))}

            <div className="absolute top-20 right-10 text-4xl animate-float opacity-60">🌸</div>
            <div className="absolute top-40 left-10 text-3xl animate-float-slow opacity-50">💕</div>
            <div className="absolute bottom-40 right-20 text-2xl animate-float opacity-40">🧁</div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40">
                <div className="max-w-2xl">
                    <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md rounded-full px-4 py-2 mb-6 animate-fade-in border border-white/30">
                        <span className="text-dulce-pink-300 animate-heart-beat">♥</span>
                        <span className="text-white/90 text-sm font-medium">Hecho con amor artesanal</span>
                        <span className="text-dulce-pink-300 animate-heart-beat">♥</span>
                    </div>

                    <h1 className="animate-slide-up">
                        <span className="block text-white/80 text-lg md:text-xl mb-2 tracking-widest uppercase">
                            {slides[currentSlide].title}
                        </span>
                        <span className="block font-great-vibes text-6xl md:text-7xl lg:text-8xl text-white mb-4 text-shadow-lg leading-tight">
                            {slides[currentSlide].subtitle}
                        </span>
                    </h1>

                    <p className="text-white/95 font-dancing text-2xl md:text-3xl mb-8 max-w-lg animate-fade-in">
                        {slides[currentSlide].description}
                    </p>

                    <div className="flex flex-wrap gap-2 mb-10 animate-fade-in">
                        {['🌿 Naturales', '💕 Con amor', '🎂 Artesanales', '🎉 Para toda ocasión'].map((feature, i) => (
                            <span key={i} className="bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm px-3 py-1.5 rounded-full border border-white/20">
                                {feature}
                            </span>
                        ))}
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 animate-slide-up">
                        <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer"
                            className="inline-flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-full shadow-2xl transform hover:scale-105 transition-all duration-300 text-lg group">
                            <FaWhatsapp size={24} className="group-hover:animate-wiggle" />
                            <span>¡Pedir por WhatsApp!</span>
                        </a>
                        <a href="#productos" onClick={(e) => { e.preventDefault(); document.querySelector('#productos')?.scrollIntoView({ behavior: 'smooth' }); }}
                            className="inline-flex items-center justify-center gap-2 bg-white/20 backdrop-blur-md hover:bg-white/30 text-white font-semibold py-4 px-8 rounded-full border border-white/30 transition-all duration-300">
                            <span>Ver Productos</span>
                            <FaArrowDown className="animate-bounce" />
                        </a>
                    </div>

                    <div className="mt-8 animate-fade-in">
                        <p className="text-white/80 text-sm">
                            📱 Pedidos al{' '}
                            <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer" className="text-green-400 hover:text-green-300 font-bold">
                                +569 93396909
                            </a>
                        </p>
                    </div>
                </div>
            </div>

            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-10">
                {slides.map((_, index) => (
                    <button key={index} onClick={() => setCurrentSlide(index)}
                        className={`h-2 rounded-full transition-all duration-500 ${index === currentSlide ? 'w-8 bg-dulce-pink-400' : 'w-2 bg-white/50 hover:bg-white/70'}`} />
                ))}
            </div>
        </section>
    );
};

export default Hero;